import { verifyStoredValue } from "./browser-storage-provider.js";

const KEY = "fishystuff.fishydex.detail-session.v1";
const SCHEMA = "fishystuff.fishydex-detail-session.v1";
const TABS = new Set(["info", "zones", "titles"]);

// Device-local open-control state. The browser tab owns its lifetime; it is
// excluded from account sync, progress exports, and durable-data resets.
export function createFishydexDetailSessionRepository({ storage, globalObject = globalThis } = {}) {
  const provider = () => storage ?? globalObject.sessionStorage;
  function load() {
    let raw;
    try { raw = provider().getItem(KEY); }
    catch (error) { return { kind: "unavailable", reason: String(error) }; }
    if (raw === null) return { kind: "missing" };
    if (typeof raw !== "string" || raw.length > 256) return { kind: "invalid" };
    let record;
    try { record = JSON.parse(raw); }
    catch { return { kind: "invalid" }; }
    if (!record || typeof record !== "object" || Array.isArray(record)) return { kind: "invalid" };
    if (record.schema !== SCHEMA) return { kind: "unsupportedVersion" };
    if (Object.keys(record).length !== 2 || !TABS.has(record.tab)) return { kind: "invalid" };
    return { kind: "ready", tab: record.tab };
  }
  function selectTab(tab) {
    if (!TABS.has(tab)) throw new TypeError("Unknown Fishydex details tab");
    const current = load();
    if (current.kind !== "ready" && current.kind !== "missing") return current;
    if (current.tab === tab) return current;
    const encoded = JSON.stringify({ schema: SCHEMA, tab });
    try {
      const target = provider();
      target.setItem(KEY, encoded);
      verifyStoredValue(target, KEY, encoded);
      return { kind: "ready", tab };
    } catch (error) { return { kind: "unavailable", reason: String(error) }; }
  }
  return Object.freeze({ load, selectTab });
}
